import React from 'react';

const IntroPisoCaucho = () => {
  return (
    <section className="pt-10 why-choose-style1">
      <div className="container">
        <div className="row mt-n1-9">
          {/* Imagen y cita */}
          <div className="col-lg-6 mt-1-9">
            <div className="text-center position-relative">
              <img src="/assets/img/productos/piso-caucho-reciclado/piso-caucho-reciclado-intro.jpg" alt="Piso de Caucho reciclado para exteriores" />
              <div className="why-choose-box d-none d-sm-block">
                <h5 className="text-white h4">
                Piso de Caucho Reciclado
                </h5>
                <span className="text-white opacity9"> Áreas de juego, espacios deportivos y más</span>
              </div>
            </div>
          </div>
          
          {/* Razones para elegir */}
          <div className="col-lg-6 mt-1-9">
            <div className="ps-xl-5">
              <div className="mb-5">
                <span className="text-primary text-uppercase small letter-spacing-4 d-block font-weight-700 mb-2">
                 Recubre área de juegos, gimnasios, etc.
                </span>
                <h2 className="mb-0 display-5 font-weight-800">
                 Piso de Caucho Reciclado para exteriores e interiores
                </h2>
              </div>
              
              {/* Razón 1 */}
              <Razon 
                iconClass="icon-arrow-right" 
                titulo="Amortiguante" 
                descripcion="Diseñado para amortiguar impactos, reduciendo el riesgo de lesiones en caso de caídas." 
              />
              
              {/* Razón 2 */}
              <Razon 
                iconClass="icon-arrow-right" 
                titulo="Antiderrapante" 
                descripcion="Proporciona excelente tracción, incluso en superficies húmedas o mojadas, garantizando mayor seguridad." 
              />
              
              {/* Razón 3 */}
              <Razon 
                iconClass="icon-arrow-right" 
                titulo="Fácil mantenimiento" 
                descripcion="Fácil de limpiar y mantener en óptimas condiciones, ya que repele el polvo y las manchas." 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Componente para cada razón
const Razon = ({ iconClass, titulo, descripcion }) => {
  return (
    <div className="d-flex mt-1-9">
      <div className="flex-shrink-0 me-4">
        <i className={`${iconClass} display-12 text-primary`}></i>
      </div>
      <div className="flex-grow-1">
        <h4 className="h5">{titulo}</h4>
        <p className="mb-0">{descripcion}</p>
      </div>
    </div>
  );
};

export default IntroPisoCaucho;
